import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <Card className="p-8">
          <div className="prose max-w-none">
            <h2 className="text-xl font-bold mb-4">Acceptance of Terms</h2>
            <p className="text-gray-600 mb-6">
              By using Daily UAE Jobs, you agree to these terms of service. If you do not agree, please do not use our services.
            </p>
            
            <h2 className="text-xl font-bold mb-4">Service Description</h2>
            <p className="text-gray-600 mb-6">
              Daily UAE Jobs provides AI-powered CV analysis, interview preparation, and career coaching services designed for the UAE job market.
            </p>
            
            <h2 className="text-xl font-bold mb-4">User Responsibilities</h2>
            <p className="text-gray-600 mb-6">
              Users are responsible for providing accurate information and maintaining the confidentiality of their account credentials.
            </p>
            
            <h2 className="text-xl font-bold mb-4">Limitation of Liability</h2>
            <p className="text-gray-600">
              Daily UAE Jobs is not responsible for job placement outcomes. Our services are designed to improve your job application materials but cannot guarantee employment.
            </p>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
